var map = {
	"./balloons.png": 643,
	"./blobs.png": 644,
	"./cleaning.png": 645,
	"./constellations.png": 646,
	"./guess_what.png": 647,
	"./memory.png": 648,
	"./memoseq.png": 649,
	"./pianoseq.png": 650,
	"./place_it.png": 651,
	"./potpourri.png": 652,
	"./quality_control.png": 653,
	"./shopping.png": 654,
	"./twister.png": 655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 196;